import * as actionTypes from '../types/workingDetailing';

const initialState = {
  listCommits: [],
  listPhotos: [],
  listFiles: [],
  okCommits: false,
  okPhoto: false,
  okFiles: false,
  okSendEmail: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.WORKING_DETAILING_GET_LIST_COMMITS_SUCCESS:
      return {
        ...state,
        listCommits: payload,
        okCommits: false
      };
    case actionTypes.WORKING_DETAILING_GET_LIST_PHOTOS_SUCCESS:
      return {
        ...state,
        listPhotos: payload,
        okPhoto: false
      };
    case actionTypes.WORKING_DETAILING_GET_LIST_FILES_SUCCESS:
      return {
        ...state,
        listFiles: payload,
        okFiles: false
      };
    case actionTypes.WORKING_DETAILING_ADD_COMMIT_SUCCESS:
      return {
        ...state,
        okCommits: true
      };
    case actionTypes.WORKING_DETAILING_ADD_PHOTO_SUCCESS:
      return {
        ...state,
        okPhoto: true
      };

    case actionTypes.WORKING_DETAILING_SEND_EMAIL:
    case actionTypes.WORKING_DETAILING_SEND_EMAIL_FAIL:
      return {
        ...state,
        okSendEmail: false
      };
    case actionTypes.WORKING_DETAILING_SEND_EMAIL_SUCCESS:
      return {
        ...state,
        okSendEmail: true
      };

    default:
      return state;
  }
};

export default reducer;
